<template>
  <vs-popup
    fullscreen
    :active.sync="modalAtivo"
    :title="'Histórico de alterações no evento'"
    @close="fecharModal"
    id="popup-personalizado"
  >
    <div class="tab">
      <div :class="`tabs ${getActiveTabClass(1)}`" @click="changeActiveTab(1)">
        <span class="font-bold">Evento</span>
      </div>
      <div :class="`tabs ${getActiveTabClass(2)}`" @click="changeActiveTab(2)">
        <span class="font-bold">Envolvidos</span>
      </div>
      <div :class="`tabs ${getActiveTabClass(3)}`" @click="changeActiveTab(3)">
        <span class="font-bold">Oficina/Reparo</span>
      </div>
    </div>

    <div class="mt-8" v-if="getActiveTab === 1">
      <div
        class="flex flex-col mb-4 break-words"
        v-for="(item, index) in historicoAlteracoesEventos"
        :key="index"
      >
        <span class="font-bold dataColor mb-2">Data {{ item.data }}</span>
        <div
          class="flex w-full borda mb-2 flex-wrap"
          v-for="(itemDados, indexDados) in item.dados"
          :key="indexDados"
        >
          <div class="modalHistoricoLinha lg:w-1/6">
            <span class="font-bold labelColor p-2">Referência</span
            ><span class="labelColor p-2">{{ itemDados.tabela }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/6">
            <span class="font-bold labelColor p-2">Campo</span
            ><span class="labelColor p-2">{{ itemDados.campo }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/5">
            <span class="font-bold labelColor p-2">Dado Antigo</span
            ><span class="labelColor p-2">{{ itemDados.dadoOldName }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/5">
            <span class="font-bold labelColor p-2">Dado Novo</span
            ><span class="labelColor p-2">{{ itemDados.dadoNewName }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/6">
            <span class="font-bold labelColor p-2">Usuário</span
            ><span class="labelColor p-2">{{ itemDados.nome }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/12 lg:text-right lg:pr-3">
            <span class="font-bold labelColor p-2">Hora</span
            ><span class="labelColor p-2">{{ itemDados.hora }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8" v-if="getActiveTab === 2">
      <div
        v-for="(item, index) in historicoAlteracoesEnvolvidos"
        :key="index"
        class="flex flex-col mb-4 break-words"
      >
        <span class="font-bold dataColor mb-2">Data {{ item.data }} </span>
        <div
          class="flex w-full borda mb-2 flex-wrap"
          v-for="(itemDados, indexDados) in item.dados"
          :key="indexDados"
        >
          <div class="modalHistoricoLinha lg:w-1/6">
            <span class="font-bold labelColor p-2">Referência</span
            ><span class="labelColor p-2">{{ itemDados.tabela }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/6">
            <span class="font-bold labelColor p-2">Campo</span
            ><span class="labelColor p-2">{{ itemDados.campo }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/5">
            <span class="font-bold labelColor p-2">Dado Antigo</span
            ><span class="labelColor p-2">{{ itemDados.dadoOldName }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/5">
            <span class="font-bold labelColor p-2">Dado Novo</span
            ><span class="labelColor p-2">{{ itemDados.dadoNewName }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/6">
            <span class="font-bold labelColor p-2">Usuário</span
            ><span class="labelColor p-2">{{ itemDados.nome }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/12 lg:text-right lg:pr-3">
            <span class="font-bold labelColor p-2">Hora</span
            ><span class="labelColor p-2">{{ itemDados.hora }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8" v-if="getActiveTab === 3">
      <div
        v-for="(item, index) in historicoAlteracoesOficina"
        :key="index"
        class="flex flex-col mb-4 break-words"
      >
        <span class="font-bold dataColor mb-2">Data {{ item.data }}</span>
        <div
          class="flex w-full borda mb-2 flex-wrap"
          v-for="(itemDados, indexDados) in item.dados"
          :key="indexDados"
        >
          <div class="modalHistoricoLinha lg:w-1/6">
            <span class="font-bold labelColor p-2">Referência</span
            ><span class="labelColor p-2">{{ itemDados.tabela }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/6">
            <span class="font-bold labelColor p-2">Campo</span
            ><span class="labelColor p-2">{{ itemDados.campo }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/5">
            <span class="font-bold labelColor p-2">Dado Antigo</span
            ><span class="labelColor p-2">{{ itemDados.dadoOldName }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/5">
            <span class="font-bold labelColor p-2">Dado Novo</span
            ><span class="labelColor p-2">{{ itemDados.dadoNewName }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/6">
            <span class="font-bold labelColor p-2">Usuário</span
            ><span class="labelColor p-2">{{ itemDados.nome }}</span>
          </div>

          <div class="modalHistoricoLinha lg:w-1/12 lg:text-right lg:pr-3">
            <span class="font-bold labelColor p-2">Hora</span
            ><span class="labelColor p-2">{{ itemDados.hora }}</span>
          </div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>
<script>
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import service from '../../services';

export default {
  name: 'historico-alteracoes-eventos',
  props: ['popupActive', 'dadosConsulta'],
  data() {
    return {
      functions,
      historicoAlteracoesEventos: [],
      historicoAlteracoesOficina: [],
      historicoAlteracoesEnvolvidos: [],
      modalAtivo: false,
      activeTab: 1,
    };
  },
  watch: {
    popupActive() {
      if (this.popupActive) {
        this.buscarHistorico();
      }
    },
  },
  computed: {
    getActiveTab() {
      return this.activeTab;
    },
  },
  methods: {
    changeActiveTab(active) {
      this.activeTab = active;
    },
    getActiveTabClass(active) {
      return this.activeTab === active ? 'activeTab' : '';
    },
    async buscarHistorico() {
      const objSend = {
        id: this.dadosConsulta,
      };
      try {
        this.$vs.loading();

        const response = await service.post(
          'logs',
          'buscar-historico-evento',
          objSend,
        );

        if (response.data.length) {
          this.separarTiposHistorico(response.data);
          this.modalAtivo = true;
        } else {
          notify.notifyFail(this.$vs, 'Não há registro de alterações');
          this.$emit('close');
        }

        this.$vs.loading.close();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        this.$emit('close');
      } finally {
        this.$vs.loading.close();
      }
    },
    verificarFormatarESeparar(texto) {
      if (!texto) return '-';

      const regexISO8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
      const regexHtml = /<[^>]*>/;

      if (regexISO8601.test(texto)) {
        return functions.formataDataISO8601(texto);
      }

      if (regexHtml.test(texto)) {
        const textoSemHtml = texto.replace(/<[^>]*>/g, ' ');
        const textoSeparadoPorVirgulas = textoSemHtml
          .trim()
          .split(/\s+/)
          .join(' ');

        return textoSeparadoPorVirgulas;
      }

      return texto;
    },
    separarTiposHistorico(historico) {
      historico.forEach((h, index) => {
        historico[index].createdAt = functions.formataDataISO8601(h.createdAt);

        if (h.dadoNewName === 'true' || h.dadoOldName === 'true') {
          h.dadoNewName = h.dadoNewName === 'true' ? 'SIM' : 'NÃO';
          h.dadoOldName = h.dadoOldName === 'true' ? 'SIM' : 'NÃO';
        }

        h.dadoNewName = this.verificarFormatarESeparar(h.dadoNewName);
        h.dadoOldName = this.verificarFormatarESeparar(h.dadoOldName);
      });

      const envolvidos = historico.filter((h) =>
        ['eventosEnvolvidos', 'eventosVeiculosEnvolvidos'].includes(h.tabela),
      );
      const oficina = historico.filter((h) =>
        ['eventosHistoricosOficinas', 'eventosReparosVeiculos'].includes(
          h.tabela,
        ),
      );
      const eventos = historico.filter(
        (h) =>
          ![
            'eventosHistoricosOficina',
            'eventosReparosVeiculos',
            'eventosEnvolvidos',
            'eventosVeiculosEnvolvidos',
          ].includes(h.tabela),
      );

      this.historicoAlteracoesEventos = functions.organizarEmDias(eventos);
      this.historicoAlteracoesOficina = functions.organizarEmDias(oficina);
      this.historicoAlteracoesEnvolvidos =
        functions.organizarEmDias(envolvidos);
    },
    fecharModal() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
.tab {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.tabs {
  position: relative;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  background: #ededed;
  color: #262626;
  padding: 1em 0 1em 0;
  cursor: pointer;
}
.activeTab {
  background: #008fcd;
  color: #ffffff;
}
.activeTab::after {
  content: '';
  position: absolute;
  bottom: -10px; /* Distância do triângulo em relação à tab */
  left: 50%;
  transform: translateX(-50%);
  border-style: solid;
  border-width: 10px 8px 0 8px;
  border-color: #3a91cf transparent transparent transparent;
  z-index: 1;
}
.dataColor {
  color: #114880;
}
.labelColor {
  color: black;
  font-weight: 500;
}
.borda {
  border: 0.2em solid #e7e7e7;
}
</style>
<style>
#popup-personalizado.con-vs-popup .vs-popup {
  width: 98% !important;
}
#popup-personalizado .vs-popup--header {
  background: #008fcd;
}
#popup-personalizado .vs-popup--header .vs-popup--title h3 {
  color: white;
}
.modalHistoricoLinha {
  display: flex;
  flex-direction: column;
}
@media (max-width: 500px) {
  .modalHistoricoLinha {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
}
@media (min-width: 500px) {
  .modalHistoricoLinha {
    display: flex;
    flex-direction: column;
    width: 50%;
  }
}
</style>
